import { render, staticRenderFns } from "./EditSurveyTemplateView.vue?vue&type=template&id=4b9eb172&scoped=true&"
import script from "./EditSurveyTemplateView.vue?vue&type=script&lang=js&"
export * from "./EditSurveyTemplateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9eb172",
  null
  
)

export default component.exports